import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import PersonalData from "./PersonalData/PersonalData";
import MyText from "../../../../components/UI/Text/MyText";
import {Alert, Flex, Tabs} from "antd";
import {Link} from "react-router-dom";

const SettingsPage = () => {
    const {user, isLoading} = useSelector(state => state.user);
    const dispatch = useDispatch();
    const onChangeTabs = async (key) => {
        if (key === '1') {

        }
    };
    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'personalData'}/>,
            children: <PersonalData/>,
        }
    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'settings'}/></MyText>
            {!user?.profile?.isFullFilled &&
                <Alert
                    style={{
                        width: "100%"
                    }}
                    type={"info"}
                    showIcon
                    message={<strong><IntlMessage id={'formPage.instruction.warning'}/></strong>}
                    description={
                        <Flex vertical gap={10}>
                            <p><IntlMessage id={'needToFillProfile'}/></p>
                        </Flex>
                    }
                />
            }
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems} onChange={onChangeTabs}/>
        </Flex>
    );
};

export default SettingsPage;